import React from "react";
import ExternalLinkButton from "./ExternalLinkButton/ExternalLinkButton";
import InternalLinkButton from "./InternalLinkButton/InternalLinkButton";
import MainButton from "./MainButton/MainButton";

const BUTTON_COMPONENTS = {
  main_button: MainButton,
  internal_link_button: InternalLinkButton,
  external_link_button: ExternalLinkButton,
};

const SharedContainerButtons = ({ options = {} }) => {
  const { main_btn_version } = options;

  const ButtonComponent = BUTTON_COMPONENTS[main_btn_version];

  if (!ButtonComponent) return null;

  return <ButtonComponent options={options} />;
};

export default SharedContainerButtons;
